export default function isNumEqualIsh(a, b) {
	return Number(a) === Number(b);
}
